import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCustomers } from '../../../appRedux/actions';
import { phoneMask } from '../../../util';
import { Select, Spin, Divider, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ModalView } from '../../uiComponents';
import { useCustomModal } from '../../../hooks/useCustomModal';
import { CustomerForm } from '../../components/Customer/CustomerForm';
import { debounce } from 'lodash';
import {
  buttonLabel,
  minLengthValidation,
  placeHolders,
} from '../../../constants';

export const CustomerSearchSelect = ({
  value,
  onChange,
  minLength = 3,
  showAddCustomer = true,
  disabled = false,
}) => {
  const dispatch = useDispatch();
  const { customers } = useSelector((state) => state.customer);
  const { modal } = useCustomModal();

  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const debouncedFetch = useMemo(
    () =>
      debounce(async (value) => {
        setLoading(true);
        await dispatch(
          getAllCustomers({
            withDeleted: 'false',
            search: value,
          })
        );
        setLoading(false);
      }, 600),
    [dispatch]
  );

  useEffect(() => {
    if (!search || search.length < minLength) {
      setLoading(false);
      debouncedFetch.cancel();
      return;
    }

    debouncedFetch(search);

    return () => {
      debouncedFetch.cancel();
    };
  }, [search, minLength, debouncedFetch]);

  const options = customers?.map((customer) => ({
    value: customer.id,
    label: `${customer.name} ${customer.lastName} - ${phoneMask(
      customer.mobilePhone
    )}`,
  }));

  return (
    <>
      <Select
        showSearch
        allowClear
        value={value}
        filterOption={false}
        onSearch={setSearch}
        disabled={disabled}
        onChange={(val) => onChange?.(val || null)}
        notFoundContent={
          loading ? (
            <Spin size="small" />
          ) : search.length < minLength ? (
            minLengthValidation('Paciente', minLength)
          ) : (
            placeHolders.noResult
          )
        }
        dropdownRender={(menu) => (
          <>
            {menu}

            {showAddCustomer && (
              <>
                <Divider />
                <Button
                  type="link"
                  icon={<PlusOutlined />}
                  onClick={() => modal()}
                  disabled={disabled}
                >
                  {buttonLabel.refresh}
                </Button>
              </>
            )}
          </>
        )}
        options={options}
      />

      {showAddCustomer && (
        <ModalView title={placeHolders.addPatient} width={900}>
          <CustomerForm onModal={true} />
        </ModalView>
      )}
    </>
  );
};
